module.exports = __webpack_public_path__ + "static/media/D-DINCondensed-Bold.19310716.otf";